import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import { ComboboxField } from '../../../Components/formElements/ComboboxField';
import Layout from "../../Layout/Layout";
// import POColumnChart from "./Charts/POColumnChart";
import BarChart from "./Charts/DonutChart";
import ProcurementPipeline from "./Charts/ProcurementPipeline";
import { useNavigate } from "react-router-dom";

import ActionCenter from "./Charts/ActionCenterChart";

import SpendOverTimeChart from "./Charts/SpendOverTimeChart";
import SpendCategoryChart from "./Charts/SpendCategoryChart";
import TopSuppliers from "./Charts/TopSuppliers";

import { getGoodsReceivedNote } from "../../redux/feature/supplier_app/purchasingSlice";

// import RecentActivities from "./Charts/RecentActivities";
import Alerts from "./Charts/Alerts";
// import AIInsights from "./Charts/AIInsights";

//Serivce
import ItemService from "../../services/supplier_appCommonService";
import LoaderSmall from "../../Components/LoaderSmall";
import { useDispatch } from "react-redux";
import { formatToTwoDigits, getCurrentDate } from "../../common/Validations";
import DatePickerComponent from "./Charts/FilterComponent/DatePickerComponent";
import SupplierConstants from "../../common/SupplierConstants";
import { useSelector } from "react-redux";

const Dashboard = () => {
  localStorage.setItem("menu", "Dashboard");
  localStorage.setItem("submenu", "-");
  const navigate = useNavigate();

  const dispatch = useDispatch();

  let userInfo = useSelector((state) => state?.user?.data);

  let goods_received_noteData = useSelector(
    (state) => state?.purchasing?.goods_received_note,
  );
  const [roleLoading, setRoleLoading] = useState(true);
  const [isVendor, setIsVendor] = useState(false);

  const isAdmin = userInfo?.roles?.some((role) => role.roleId === "ADMIN");

  useEffect(() => {
    if (userInfo?.roles) {
      const vendor = userInfo.roles.some((role) => role.roleId === "VENDOR");

      setIsVendor(vendor);
      setRoleLoading(false);
    }
  }, [userInfo]);
  const navigateToMainPage = (page) => {
    if (page === "supplier") {
      navigate(SupplierConstants.SUPPILER_LIST);
    } else if (page === "users") {
      navigate(SupplierConstants.ADMIN_MANAGE_USER_LIST);
    } else if (page === "pr") {
      navigate(SupplierConstants.SOURCING_PURCHASE_REQUISITION_LIST);
    } else if (page === "po") {
      navigate(SupplierConstants.POCOLLABRATION_PURCHASE_ORDER_LIST);
    } else if (page === "rfq") {
      if (isAdmin) {
        navigate(SupplierConstants.SOURCING_BUYER_REQUEST_FOR_QUOTATION);
      } else {
        navigate(SupplierConstants.SOURCING_VENDOR_REQUEST_FOR_QUOTATION);
      }
    } else if (page === "INV") {
      navigate(SupplierConstants.POCOLLABRATION_INVOICE);
    } else if (page === "ASN") {
      navigate(SupplierConstants.POCOLLABRATION_ASN);
    }
  };

  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = String(today.getMonth() + 1).padStart(2, "0");

  const [filterShow, setFilterShow] = useState(false);

  const [prAgeing, setPrAgeing] = useState({});
  const [prAgeingStatus, setPrAgeingStatus] = useState(false);

  const [actionCenterData, setActionCenterData] = useState([]);

  const [dashboardAlert, setDashboardAlert] = useState({});

  const [prCategoryData, setPrCategoryData] = useState({});
  const [poCategoryData, setPoCategoryData] = useState({});
  const [prCategoryLoading, setPrCategoryLoading] = useState(false);
  const [poCategoryLoading, setPoCategoryLoading] = useState(false);

  const [selectedSpendType, setSelectedSpendType] = useState("PO");

  const [procurementPipelineValues, setProcurementPipelineValues] = useState({
    pr: "00",
    rfq: "00",
    eval: "00",
    po: "00",
    grn: "00",
    invoice: "00",
  });

  useEffect(() => {
    if (goods_received_noteData?.total !== undefined) {
      console.log("Inside GRN useEffect : ", goods_received_noteData.total);
      setProcurementPipelineValues((prev) => ({
        ...prev,
        grn: goods_received_noteData.total,
      }));
    }
  }, [goods_received_noteData]);

  const [totalPoCount, setTotalPoCount] = useState("");
  const [totalPoCountStatus, setTotalPoCountStatus] = useState(false);

  const [totalInvoiceCount, setTotalInvoiceCount] = useState("");
  const [totalInvoiceCountStatus, setTotalInvoiceCountStatus] = useState(false);

  const prAgeingData = async () => {
    setPrAgeingStatus(true);
    let obj = { prStatusHeader: "In Release" };

    await ItemService.prAgeing(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        console.log("PR Ageing Data: ", item?.data);
        // setPrCount(item.data[0].count);
        setPrAgeing(item?.data);
      } else {
        toast.error(item?.message || "Please try again for PR Ageing", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setPrAgeingStatus(false);
  };

  const loadPRCategoryCounts = async () => {
    setPrCategoryLoading(true);
    try {
      const res = await ItemService.getPRCategoryCounts({});
      if (res?.status === 200) {
        // Transform array -> object: { "100 - Raw Material": 50, ... }
        const dataObject = res.data.reduce((acc, item) => {
          acc[item.category] = item.count;
          return acc;
        }, {});
        setPrCategoryData(dataObject);
      } else {
        toast.error(res?.message || "Failed to load PR category counts");
      }
    } catch (err) {
      toast.error("Error fetching PR category counts");
    }
    setPrCategoryLoading(false);
  };

  const loadPOCategoryCounts = async () => {
    setPoCategoryLoading(true);
    try {
      const res = await ItemService.getPOCategoryCounts({});
      if (res?.status === 200) {
        const dataObject = res.data.reduce((acc, item) => {
          acc[item.category] = item.count;
          return acc;
        }, {});
        setPoCategoryData(dataObject);
      } else {
        toast.error(res?.message || "Failed to load PO category counts");
      }
    } catch (err) {
      toast.error("Error fetching PO category counts");
    }
    setPoCategoryLoading(false);
  };

  //po count

  const loadActionCenter = async () => {
    let obj = {
      workflowStatus: "Open",
    };

    await ItemService.getWorkflowInboxCards(obj).then((item) => {
      if (item?.status === 200) {
        console.log("Get Workflow inbox card : ", item.data);
        setActionCenterData(item.data);
      } else {
        toast.error(
          item?.message || "Please try again for Action Center Data",
          {
            duration: 4000,
            position: "top-right",
          },
        );
      }
    });
  };

  const dashboardAlertsData = async () => {
    try {
      const response = await ItemService.dashboardAlerts({});
      if (response?.status === 200) {
        console.log("Dashboard Alert:", response.data);
        setDashboardAlert(response.data);
      } else {
        toast.error(response?.message || "Unable to fetch dashboard alerts");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const loadEvaluatedRFQ = async () => {
    let obj = {};

    await ItemService.getEvaluatedRfq(obj).then((item) => {
      // getEvaluatedRFQ
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        // setTotalRfqCount(item.total);
        // setProcurementPipelineValues({
        //   ...procurementPipelineValues,
        //   rfq: item.total
        // });
        setProcurementPipelineValues((prev) => ({
          ...prev,
          eval: item.total,
        }));
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
  };

  //PO
  const loadPoCount = async () => {
    setTotalPoCountStatus(true);
    let obj = {
      module: "PO",
      queryName: "getMaterialPO",
      page: 1,
      per_page: 10,
    };

    await ItemService.generateQuery(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setTotalPoCount(item.total);
        // setProcurementPipelineValues({
        //   ...procurementPipelineValues,
        //   po: item.total
        // });
        setProcurementPipelineValues((prev) => ({
          ...prev,
          po: item.total,
        }));
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalPoCountStatus(false);
  };

  //invoice
  // const loadInvoiceCount = async () => {
  //   setTotalInvoiceCountStatus(true);
  //   let obj = {
  //   queryName: "getInvoiceListVendor",
  //   module: "INVOICE",
  //   page: 1,
  //   per_page: 10,
  //   }
  //   await ItemService.generateQuery(obj).then((item) => {
  //     // console.log(">> Details res!", item);
  //     if (item?.status === 200) {
  //       setTotalInvoiceCount(item.total);
  //     } else {
  //       toast.error(item?.message || "Please try again for Total User Count", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }
  //   });
  //   setTotalInvoiceCountStatus(false);
  // };
  const loadInvoiceCount = async () => {
    setTotalInvoiceCountStatus(true);

    let obj = {
      queryName: "getInvoiceListVendor",
      module: "INVOICE",
      page: 1,
      per_page: 10,
    };

    if (!isAdmin) {
      obj.rowFilter = {
        vendorCode: JSON.parse(localStorage.getItem("userData"))?.data?.userId,
      };
    }

    await ItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalInvoiceCount(item.total);
        // setProcurementPipelineValues({ ...procurementPipelineValues, invoice: item.total })
        // setProcurementPipelineValues({
        //   ...procurementPipelineValues,
        //   invoice: item.total
        // });
        setProcurementPipelineValues((prev) => ({
          ...prev,
          invoice: item.total,
        }));
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

    setTotalInvoiceCountStatus(false);
  };

  // Suppliers Chart
  const suppliersChart = async (filterData) => {
    let requestData = {
      ...filterData,
      module: "supplier",
      chartType: "column",
    };

    await ItemService.dashboard(requestData).then((item) => {
      // console.log(">> dashboard res!", item);
      if (item?.status === 200) {
        if (item.data && typeof item.data === "object") {
          item.data.module = "supplier";
        } else {
          toast.error(
            item?.message || "Please try again for Total User Count",
            {
              duration: 4000,
              position: "top-right",
            },
          );
        }
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
  };

  const loadGrnCount = async () => {
    let obj = {
      page: 1,
      per_page: 10,
      searchTerm: "",
    };

    dispatch(getGoodsReceivedNote(obj));

    await ItemService.getGoodsReceivedNote(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        // setTotalRfqCount(item.total);
        // setProcurementPipelineValues({
        //   ...procurementPipelineValues,
        //   rfq: item.total
        // });
        setProcurementPipelineValues((prev) => ({
          ...prev,
          grn: item.total,
        }));
      } else {
        toast.error(item?.message || "Please try again for Total GRN Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    // setTotalRfqCountStatus(false);
  };
  // setData(goods_received_noteData?.data);

  // console.log('Dashboard GRN Data: ', goods_received_noteData)
  // console.log('Dashboard GRN Count: ', goods_received_noteData?.total)

  // console.log('Dashboard GRN Data: ', res)
  // console.log('Dashboard GRN Count: ', res?.total)
  // setProcurementPipelineValues(prev => ({
  //   ...prev,
  //   grn: res?.total,
  // }));
  // };

  // PO Chart
  // const poChart = async (filterData) => {
  //   setPOStatusColChartStatus(true);
  //   let requestData = { ...filterData, module: "po", chartType: "pie" };

  //   await ItemService.dashboard(requestData).then((item) => {
  //     // console.log(">> dashboard res!", item);
  //     if (item?.status === 200) {
  //       if (item.data && typeof item.data === "object") {
  //         item.data.module = "po";
  //         setPOStatusColChart(item.data);
  //       } else {
  //         toast.error(item?.message || "Please try again for Total User Count", {
  //           duration: 4000,
  //           position: "top-right",
  //         });
  //       }
  //     } else {
  //       toast.error(item?.message || "Please try again for Total User Count", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }
  //   });
  //   setPOStatusColChartStatus(false);
  // };

  // On Filtered Data

  const handleFilterData = async (filter) => {
    // console.log(">> filter", filter);

    await suppliersChart(filter);
    // await poChart(filter);
  };

  useEffect(() => {
    let defaultFilter = {
      action: "Monthly",
      month: currentMonth,
      year: currentYear,
    };

    loadEvaluatedRFQ();
    loadPoCount();
    loadInvoiceCount();
    loadGrnCount();
    prAgeingData();
    loadActionCenter();
    dashboardAlertsData();

    loadPRCategoryCounts(); // <--- add
    loadPOCategoryCounts();

    suppliersChart(defaultFilter);
    // poChart(defaultFilter);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="dashboard main" id="main">
      <Layout />

      <style>{`
.dashboardCardNew {
    background: #fff;
    border-radius: 16px;
    padding: 15px;
    display: flex;
    align-items: center;
    gap: 16px;
    height: 120px;
    box-shadow: 0px 5px 30px rgba(0,0,0,.08);
    transition: all .3s ease;
    // border: 2px solid red;
}

.dashboardCardNew:hover{
    transform: translateY(-2px);
    box-shadow:0 8px 20px rgba(0,0,0,.12);
    cursor:pointer;
}

.dashboardIcon{
    width:65px;
    height:65px;
    border-radius:12px;
    display:flex;
    justify-content:center;
    align-items:center;
    font-size:26px;
    //  border: 2px solid green;
}

.dashboardIcon.blue{
    background:#EAF2FF;
    color:#2563EB;
}

.dashboardIcon.green{
    background:#E8F9EE;
    color:#22C55E;
}

.dashboardIcon.purple{
    background:#F2EBFF;
    color:#7C3AED;
}

.dashboardIcon.orange{
    background:#FFF3E8;
    color:#F97316;
}

.dashboardIcon.teal{
    background:#E6FAF8;
    color:#14B8A6;
}

.dashboardContent{
    flex:1;
}

.dashboardTitle{
    font-size:14px;
    color:#7A7A7A;
    font-weight:500;
    margin-bottom:4px;
}

.dashboardCount{
    font-size:32px;
    font-weight:700;
    margin-bottom:6px;
    color:#222;
}

.dashboardBottom{
    display:flex;
    align-items:center;
    gap:10px;
}

.dashboardIncrease{
    color:#16A34A;
    font-size:13px;
    font-weight:600;
}

.dashboardDecrease{
    color:#DC2626;
    font-size:13px;
    font-weight:600;
}

.dashboardMonth{
    font-size:12px;
    color:#9CA3AF;
}

.dashboardCardNew {
  position: relative;
}

.dashboardArrowButton {
  position: absolute;
  right: 12px;
  bottom: 12px;

  width: 28px;
  height: 28px;

  border: none;
  border-radius: 4px;

  background-color: #3f51db;
  color: white;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  font-size: 16px;
}

.dashboardArrowButton:hover {
  background-color: #3245c5;
}

.dashboardWidget {

    background:#fff;
    border-radius:14px;
    padding:15px;
    height:180px;
    box-shadow:0 5px 25px rgba(0,0,0,.08);

}


.widgetHeader {

    display:flex;
    justify-content:space-between;
    align-items:center;
    margin-bottom:12px;

}


.widgetHeader h6 {

    font-size:14px;
    font-weight:600;
    margin:0;

}


.widgetHeader span {

    font-size:10px;
    color:#2563eb;
}



/* Action Center */

.actionItem {

    display:flex;
    justify-content:space-between;
    align-items:center;
    padding:5px 0;
    font-size:12px;
    border-bottom:1px solid #f2f2f2;

}


.badge {

    padding:2px 8px;
    border-radius:5px;
    font-size:11px;

}


.badge.red{
    background:#ffe3e3;
    color:#ef4444;
}

.badge.orange{
    background:#fff1df;
    color:#f97316;
}

.badge.blue{
    background:#e8f0ff;
    color:#2563eb;
}

.badge.green{
    background:#e7f8ee;
    color:#16a34a;
}
    .supplierTable {
    margin-bottom: 0;
}

.supplierTable thead th {
    font-size: 14px;
    font-weight: 600;
    color: #6B7280;
    border-bottom: 2px solid #E5E7EB;
    padding: 14px;
}

.supplierTable tbody td {
    padding: 16px 14px;
    vertical-align: middle;
}

.supplierTable tbody tr {
    transition: 0.3s;
}

.supplierTable tbody tr:hover {
    background: #F9FAFB;
}

.supplierTable .badge {
    font-size: 13px;
    padding: 7px 12px;
    border-radius: 8px;
}




/* Pipeline */

.pipeline {

    display:flex;
    align-items:center;
    justify-content:center;
    margin-top:25px;

}


.pipelineItem {

    text-align:center;

}


.pipelineItem p {

    font-size:10px;
    color:#777;
    margin:6px 0 0;

}


.pipelineItem h5 {

    font-size:18px;
    margin:2px 0;
    font-weight:700;

}



.pipelineIcon {

    width:28px;
    height:28px;
    border-radius:50%;
    display:flex;
    align-items:center;
    justify-content:center;
    color:white;
    font-size:13px;

}


.pipelineIcon.blue{
    background:#2563eb;
}

.pipelineIcon.green{
    background:#14b87a;
}

.pipelineIcon.purple{
    background:#8b5cf6;
}

.pipelineIcon.orange{
    background:#f97316;
}



.line {

    width:25px;
    border-top:1px dashed #bdbdbd;

}




/* PR Ageing */

.ageingContainer {

    display:flex;
    align-items:center;
    justify-content:center;
    gap:25px;

}



.circleChart {

    width:95px;
    height:95px;
    border-radius:50%;
    background:
    conic-gradient(
        #2563eb 0deg 200deg,
        #14b8a6 200deg 280deg,
        #f97316 280deg 320deg,
        #ef4444 320deg
    );

    display:flex;
    align-items:center;
    justify-content:center;

}


.circleChart div {

    width:65px;
    height:65px;
    background:white;
    border-radius:50%;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;

}


.circleChart h4 {

    margin:0;
    font-size:18px;

}


.circleChart span {

    font-size:10px;
    color:#777;

}



.ageingList p {

    font-size:11px;
    display:flex;
    align-items:center;
    gap:8px;
    margin:8px 0;

}


.ageingList b {

    margin-left:auto;

}


.dot {

    width:8px;
    height:8px;
    border-radius:50%;

}


.blueDot{
    background:#2563eb;
}

.greenDot{
    background:#14b8a6;
}

.orangeDot{
    background:#f97316;
}

.redDot{
    background:#ef4444;
}
    .dashboardWidget{
    background: #fff;
    border: none;
    border-radius: 14px;
    padding: 15px;
    box-shadow: 0 5px 25px rgba(0,0,0,.08);
    height: 93%;
}
    .dashboardWidget2{
    background:#fff;
    border:none;
    border-radius:14px;
    padding:16px;
    box-shadow:0 5px 25px rgba(0,0,0,.08);
    height:400px;
    min-height: max-content;
    display:flex;
    flex-direction:column;
}

.dashboardChartWidget2{
    height:280px;
    display:flex;
    flex-direction:column;

}


.dashboardChartWidget2 .widgetHeader{
    margin-bottom:12px;
}


.dashboardChartWidget2 .widgetHeader h6{

    font-size:14px;
    font-weight:600;
    color:#2b2b2b;
}


.dashboardChartWidget2 .widgetHeader span{

    font-size:11px;
    color:#2563eb;
    cursor:pointer;
}


.dashboardChartWidget2 .chartBody{
    flex:1;
    display:flex;
    align-items:center;
    justify-content:center;
}

// .dashboardWidget3{

//     background:#fff;
//     border:none;
//     border-radius:14px;
//     box-shadow:0 5px 25px rgba(0,0,0,.08);
//     padding:15px;
//     height:280px;
//     // border: 2px solid red;
//     min-height: max-content;

// }

// .dashboardWidget3 .widgetHeader3{

//     display:flex;
//     justify-content:space-between;
//     align-items:center;
//     margin-bottom:15px;

// }

// .dashboardWidget3 .widgetHeader3 h6{

//     margin:0;
//     font-size:14px;
//     font-weight:600;

// }

// .dashboardWidget3 .widgetHeader3 span{

//     color:#2563EB;
//     font-size:11px;
//     cursor:pointer;
// }

.dashboardWidget3 {
    background: #fff;
    border-radius: 16px;
    padding: 20px;
    height: 400px;
    display: flex;
    flex-direction: column;
    box-shadow:0 5px 25px rgba(0,0,0,.08);
}

.widgetHeader3 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;
    
}

.widgetHeader3 h6 {
    margin: 0;
    font-weight: 600;
}

.widgetHeader3 span {
    color: #2563EB;
    cursor: pointer;
    font-size: 14px;
    
}

.activityRow{

display:flex;
justify-content:space-between;
align-items:center;
padding:10px 0;
border-bottom:1px solid #f2f2f2;


}

.activityLeft{

display:flex;
align-items:center;
gap:10px;
width:75%;

}

.activityLeft span{

font-size:12px;
color:#444;


}

.activityIcon{

width:28px;
height:28px;
border-radius:50%;
display:flex;
justify-content:center;
align-items:center;
color:#fff;
font-size:13px;


}

.activityRow small{

font-size:10px;
color:#999;

}

.alertsContainer {
    flex: 1;
    overflow-y: auto;
}

.alertItem{

display:flex;
align-items:center;
gap:14px;
padding:14px;
border: 1px solid #E5E7EB;
border-radius: 12px;
margin-bottom: 12px;
transition: all .25s ease;
cursor: pointer;

}

.alertItem:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,.08);
}

.alertIcon {
    width: 42px;
    height: 42px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    flex-shrink: 0;
}

.alertText {
    font-size: 14px;
    color: #374151;
    line-height: 1.5;
    font-weight: 500;
}

.alertItem i{

color:#EF4444;

}

.insightItem{

display:flex;
align-items:flex-start;
gap:10px;
margin-bottom:14px;
font-size:12px;

}

.robotContainer{

display:flex;
justify-content:flex-end;
margin-top:5px;

}

.robotIcon{

font-size:64px;
color:#3B82F6;

}

`}</style>

      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner timesheet">
            <Row>
              <Col xs={10} md={10}>
                <h2 className="mainTitle">
                  Dashboard
                  <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                    {getCurrentDate()}
                  </span>
                </h2>
                {/* <p className="subText my-0">Dashboard detailed page</p> */}
                <p className="subText my-0">
                  Overview of Procurement performance and system activities
                </p>
              </Col>
              <Col xs={2} md={2}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />

            {filterShow && (
              <DatePickerComponent
                getfiltereddata={handleFilterData}
                cancelAction={() => setFilterShow(!filterShow)}
              />
            )}

            <section className="section">
              <div className="row mt-1">
                <div className="col-lg-3 commTopButtonRightLeftPadding">
                  <div className="dashboardCardNew">
                    <div className="dashboardIcon orange">
                      <i className="bi bi-cart3"></i>
                    </div>

                    <div className="dashboardContent">
                      <h6 className="dashboardTitle">Purchase Order</h6>

                      <h3 className="dashboardCount">
                        <LoaderSmall isLoading={totalPoCountStatus} />
                        {!totalPoCountStatus ? totalPoCount || 0 : ""}
                      </h3>

                      {/* <div className="dashboardBottom">
                        <span className="dashboardIncrease">
                          <i className="bi bi-arrow-up"></i> 12%
                        </span>

                        <span className="dashboardMonth">
                          vs Apr 2024
                        </span>
                      </div> */}
                    </div>

                    {/* Bottom Right Button */}
                    <button
                      className="dashboardArrowButton"
                      onClick={() => navigateToMainPage("po")}
                    >
                      <i className="bi bi-arrow-right"></i>
                    </button>
                  </div>
                </div>

                <div className="col-lg-3 commTopButtonRightLeftPadding">
                  <div className="dashboardCardNew">
                    <div className="dashboardIcon teal">
                      <i className="bi bi-receipt"></i>
                    </div>

                    <div className="dashboardContent">
                      <h6 className="dashboardTitle">Invoice</h6>

                      <h3 className="dashboardCount">
                        <LoaderSmall isLoading={totalInvoiceCountStatus} />
                        {!totalInvoiceCountStatus
                          ? formatToTwoDigits(totalInvoiceCount || 0)
                          : ""}
                      </h3>
                    </div>

                    {/* Bottom Right Button */}
                    <button
                      className="dashboardArrowButton"
                      onClick={() => navigateToMainPage("INV")}
                    >
                      <i className="bi bi-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </div>

              {false && !roleLoading && !isVendor && (
                <>
                  <div className="row mt-2">
                    {/* My Action Center */}

                    <div className="col-lg-3 commTopButtonRightLeftPadding">
                      <ActionCenter actions={actionCenterData} />
                    </div>

                    {/* Procurement Pipeline */}

                    <div className="col-lg-5 commTopButtonRightLeftPadding">
                      <ProcurementPipeline values={procurementPipelineValues} />
                    </div>

                    {/* PR Ageing */}
                    <div className="col-lg-4 commTopButtonRightLeftPadding">
                      <div className="card dashboardWidget">
                        <div className="card-body">
                          <h5 className="card-title">PR Ageing</h5>
                          <div id="donutChart"></div>
                          <LoaderSmall isLoading={prAgeingStatus} />
                          <BarChart data={prAgeing} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-1">
                    {/* Spend By Category */}
                    <div className="col-lg-6 commTopButtonRightLeftPadding">
                      <div className="dashboardWidget2 dashboardChartWidget">
                        <div className="widgetHeader">
                          <h6>Spend by Category</h6>
                        </div>

                        <div className="d-flex gap-2 mb-3">
                          <button
                            className={`btn ${selectedSpendType === "PO" ? "btn-primary" : "btn-light"}`}
                            onClick={() => setSelectedSpendType("PO")}
                          >
                            PO
                          </button>

                          <button
                            className={`btn ${selectedSpendType === "PR" ? "btn-primary" : "btn-light"}`}
                            onClick={() => setSelectedSpendType("PR")}
                          >
                            PR
                          </button>
                        </div>

                        {/* <SpendCategoryChart /> */}
                        {/* <SpendCategoryChart
                      data={selectedSpendType === "PO" ? poCategoryData : prCategoryData}
                      type={selectedSpendType}
                    /> */}

                        {/* Instead of just the chart, you might wrap it with a loader */}
                        {selectedSpendType === "PO" ? (
                          poCategoryLoading ? (
                            <LoaderSmall />
                          ) : (
                            <SpendCategoryChart
                              data={poCategoryData}
                              type="PO"
                            />
                          )
                        ) : prCategoryLoading ? (
                          <LoaderSmall />
                        ) : (
                          <SpendCategoryChart data={prCategoryData} type="PR" />
                        )}
                      </div>
                    </div>

                    <div className="col-lg-6 commTopButtonRightLeftPadding">
                      <Alerts
                        prAgeing={prAgeing}
                        dashboardAlert={dashboardAlert}
                      />
                    </div>
                  </div>
                  <div className="row mt-3 mb-3">
                    {/* Spend Over Time */}
                    <div className="col-lg-6 commTopButtonRightLeftPadding">
                      <div className="dashboardWidget2 dashboardChartWidget">
                        <div className="widgetHeader">
                          <h6>Spend Over Time</h6>
                        </div>
                        <SpendOverTimeChart />
                      </div>
                    </div>

                    {/* Top Suppliers */}
                    <div className="col-lg-6 commTopButtonRightLeftPadding">
                      <div className="dashboardWidget2 dashboardChartWidget">
                        <div className="widgetHeader">
                          <h6>Top Suppliers</h6>
                        </div>
                        <TopSuppliers />
                      </div>
                    </div>
                  </div>
                </>
              )}
            </section>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default Dashboard;
